// src/services/sepet.js
import db from '@/db';

/**
 * Backend çağrısı (axios instance: api)
 * Beklenen dönüş: data.response => [{ guid: '...', adet: 2 }, ...]
 */
async function fetchBackendBasket(kod, api) {
    if (!kod) return [];

    try {
        const res = await api.post('basket/listV3', { ckod: kod });
        console.log(res)
        // data.response bir array değilse hata say
        if (!res.response || !Array.isArray(res.response)) {
            throw new Error('Backend basket response must be an array (data.response).');
        }

        return res.response;
    } catch (err) {
        console.error('fetchBackendBasket ERROR:', err);
        throw err;
    }
}

/**
 * Ana işlem:
 * - backend’den sepeti al
 * - olduğu gibi carinin basket alanına yaz
 */
export async function loadAndSetBasketForCari(kod, api, cariGuid) {
    if (!cariGuid) {
        throw new Error('cariGuid gerekli');
    }

    // 1) Backend’den sepeti çek
    const basket = await fetchBackendBasket(kod, api);

    // 2) cariye yaz (caris tablosu)
    await db.caris.where('guid').equals(cariGuid).modify(c => {
        c.basket = basket;
    });

    return basket;
}

/**
 * Helper:
 * Aktif cari objesini verip sepeti yüklemek için:
 * store/cari objesinde { kod, guid } olduğunu varsayıyorum.
 */
export async function set(api, cari) {
    //console.log(cari)
    // cari: { kod, guid, ... }
    if (!cari || !cari.kod || !cari.guid) {
        throw new Error('set(api, cari) için cari.kod ve cari.guid zorunlu');
    }

    return await loadAndSetBasketForCari(cari.kod, api, cari.guid);
}

export default {
    fetchBackendBasket,
    loadAndSetBasketForCari,
    set
};



// WEBPACK FOOTER //
// ./src/services/sepet.js